import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "Aurelia Hospitality Group";
const DEFAULT_DESC = "Luxury hotels and hospitality careers in Singapore — Marina Bay, Sentosa Cove, Orchard and Fullerton Quay.";
const PAGES = [
  [/^\/$/, `${SITE} | Luxury Hotels · Careers · Singapore`, DEFAULT_DESC],
  [/^\/properties\/?$/, `Our Singapore Hotels | ${SITE}`, "Explore Aurelia hotels in Singapore: rooms and suites, signature dining, spa, rooftop pools, weddings and conference venues."],
  [/^\/properties\/.+/, `Hotel, Rooms & Facilities | ${SITE}`, "Rooms, suites, dining, spa, wellness and event spaces at an Aurelia luxury hotel in Singapore. Send a request to book."],
  [/^\/careers\/?$/, `Hotel Jobs in Singapore | Careers at ${SITE}`, "Open hospitality jobs at Aurelia hotels in Singapore across front office, F&B, culinary, housekeeping, spa and more."],
  [/^\/careers\/.+/, `Job Opening | Careers at ${SITE}`, "Responsibilities, requirements and how to apply for this hospitality role at Aurelia Hospitality Group, Singapore."],
  [/^\/register/, `Create a Candidate Profile | ${SITE}`, "Create your Aurelia Careers profile to apply for hotel jobs in Singapore and track your applications."],
  [/^\/login/, `Sign In | ${SITE}`, "Sign in to your Aurelia Careers candidate portal."],
];

export const RouteSeo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const [, title, desc] = PAGES.find(([re]) => re.test(pathname)) || [null, SITE, DEFAULT_DESC];
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", desc);
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = `${window.location.origin}${pathname}`;
  }, [pathname]);
  return null;
};
